import React, { useState } from "react";
import { Coffee, Leaf, Sparkles, CircleDot } from "lucide-react";

const ITEMS = [
  {
    key: "coffee",
    label: "Coffee",
    icon: Coffee,
    hint: "Premium Chikmagalur blend — the backbone of the experience.",
  },
  {
    key: "ashwagandha",
    label: "Ashwagandha",
    icon: Leaf,
    hint: "A natural compound traditionally used to support calm focus.",
  },
  {
    key: "brahmi",
    label: "Brahmi",
    icon: Sparkles,
    hint: "Long used to help sharpen attention and mental clarity.",
  },
  {
    key: "reishi",
    label: "Reishi",
    icon: CircleDot,
    hint: "A refined natural element to round out and balance the experience.",
  },
];

export default function Ingredients() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="ingredients"
      data-testid="ingredients-section"
      className="relative py-20 md:py-28 border-y border-[color:var(--fs-hairline)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-center gap-3 mb-10">
          <span className="h-[1px] w-10 bg-[color:var(--fs-gold-muted)]" />
          <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
            Inside the Blend
          </span>
          <span className="h-[1px] w-10 bg-[color:var(--fs-gold-muted)]" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {ITEMS.map((it, idx) => {
            const Icon = it.icon;
            const isLast = idx === ITEMS.length - 1;
            return (
              <button
                key={it.key}
                onClick={() => setActive(active === it.key ? null : it.key)}
                data-testid={`ingredient-${it.key}`}
                className={`group flex flex-col items-center text-center py-6 md:py-8 px-4 transition-all ${
                  !isLast
                    ? "md:border-r md:border-[color:var(--fs-hairline)]"
                    : ""
                }`}
              >
                <div className="relative h-20 w-20 flex items-center justify-center rounded-full border border-[color:var(--fs-hairline)] group-hover:border-[color:var(--fs-gold)] transition-all">
                  <Icon
                    size={30}
                    strokeWidth={1.3}
                    className="text-[color:var(--fs-gold-muted)] group-hover:text-[color:var(--fs-gold-hi)] transition-colors"
                  />
                </div>
                <div className="mt-5 font-display text-xl text-white tracking-wide">
                  {it.label}
                </div>
                <div
                  className={`mt-2 text-[10px] tracking-[0.22em] uppercase text-neutral-500 ${
                    active === it.key ? "opacity-100" : "opacity-60"
                  }`}
                >
                  {active === it.key ? "Tap to hide" : "Tap to learn"}
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    active === it.key
                      ? "max-h-40 mt-4 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-xs md:text-sm text-neutral-400 leading-relaxed max-w-[240px]">
                    {it.hint}
                  </p>
                </div>
              </button>
            );
          })}
        </div>

        <p className="mt-14 text-center text-xs tracking-[0.2em] uppercase text-neutral-600">
          Coffee first. Performance built in.
        </p>
      </div>
    </section>
  );
}
